import React from 'react';

const GradientBackground: React.FC = () => {
  return (
    <div 
      className="absolute w-full overflow-y-visible overflow-x-hidden pointer-events-none will-change-transform" 
      style={{ 
        height: '1200px', 
        bottom: '0',
        zIndex: '-1'
      }}
    >
      {/* Left gradient */}
      <div
        className="absolute rounded-full opacity-[0.14] will-change-transform"
        style={{
          width: '900px',
          height: '900px',
          left: '-200px',
          bottom: '-300px',
          background: 'linear-gradient(135deg, #0066FF 0%, #0044FF 100%)',
          filter: 'blur(144px)',
          transform: 'translateZ(0)',
        }}
      />
      {/* Center gradient */}
      <div
        className="absolute rounded-full opacity-[0.12] will-change-transform"
        style={{
          width: '800px',
          height: '800px',
          left: '50%',
          bottom: '-250px',
          transform: 'translateX(-50%) translateZ(0)',
          background: 'linear-gradient(135deg, #B794F6 0%, #9F7AEA 100%)',
          filter: 'blur(128px)',
        }}
      />
      {/* Right gradient */}
      <div
        className="absolute rounded-full opacity-[0.14] will-change-transform"
        style={{
          width: '900px',
          height: '900px',
          right: '-200px',
          bottom: '-300px',
          background: 'linear-gradient(135deg, #0054E6 0%, #0039D0 100%)',
          filter: 'blur(144px)',
          transform: 'translateZ(0)',
        }}
      />
    </div>
  );
};

export default GradientBackground; 